import { ChartBarIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';
import { PrimaryLinkButton } from '../../components/buttons';
import { StoreSalesStatsDisplay } from '../../components/dashboard/store-sales-stats-display';
import { EmptyState } from '../../components/empty-state';
import { useStore } from '../../hooks/use-store';

export function Dashboard() {
  const store = useStore();

  if (store.last_uploaded_at == null) {
    return (
      <EmptyState
        icon={<RocketLaunchIcon className="size-8" />}
        title="Your store hasn't uploaded any data yet"
        description="Finish setting up your store to start syncing sales and inventory."
        action={
          <PrimaryLinkButton
            to="/onboard/$storeId"
            params={{ storeId: store.id }}
            search={{ checkout: undefined }}
          >
            Complete your Onboarding
          </PrimaryLinkButton>
        }
      />
    );
  }

  if (store.sales_stats.historical.length === 0) {
    return (
      <EmptyState
        icon={<ChartBarIcon className="size-8" />}
        title="Your dashboard will populate once you start selling"
        description="Sales, margin, and transaction trends will appear here once you start ringing up sales and your next upload runs."
      />
    );
  }

  return (
    <div className="h-full w-full flex lg:flex-row overflow-y-auto flex-wrap bg-gray-200 p-4 gap-2 max-w-screen">
      <StoreSalesStatsDisplay store={store} displayType="Sales" />
      <StoreSalesStatsDisplay store={store} displayType="Gross Margin" />
      <StoreSalesStatsDisplay store={store} displayType="Transactions" />
      <StoreSalesStatsDisplay store={store} displayType="Average Order Value" />
    </div>
  );
}
